import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { GlobalContext } from "./PA";
import {
  InputCopy,
  FormGroup,
  Dropdown,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Modal,
  Head,
  FormFooter,
  Subheader,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import CardNew from "./PAcardNew";

import { Link } from "react-router-dom";

import { withRouter } from "react-router-dom";

function formatDate(date) {
  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  return day + " " + monthNames[monthIndex] + " " + year;
}

function PAlauncherVersions({handleLink = ()=>{void(0)}, ...props}) {
  console.log("props123123 = ", props);
  let d = new Date();
  d.setDate(d.getDate() - 1);


  let buttons =  {
    "Published": {
      build: true,
      download: false,
      publish: false,
    },
    "Ready": {
      build: false,
      download: true,
      publish: true,
    },
    "Building": {
      build: false,
      building: true,
      download: false,
      publish: false,
    },
  }

  let versions = {
    build1: {
      id: "build1",
      created: `${formatDate(
        new Date(Date.now() - 864e5 - 864e5 - 864e5)
      )} 17:43`,
      published: `${formatDate(new Date(Date.now() - 864e5 - 864e5))} 12:45`,
      updated: `${formatDate(new Date(Date.now() - 864e5 - 864e5))} 11:34`,
      title: "First publish",
      status: "Published",
      build: "build1.exe"
    },
    build2: {
      id: "build2",
      created: `${formatDate(new Date(Date.now() - 864e5))} 12:00`,
      published: null,
      updated: `${formatDate(
        new Date(Date.now() - 864e5 - 864e5 - 864e5)
      )} 11:43`,
      title: "Visual edits",
      status: "Ready",
      build: "build1.exe"
    },
    build3: {
      id: "build3",
      created: `${formatDate(new Date(Date.now() - 864e5))} 9:43`,
      published: null,
      updated: `${formatDate(new Date())} 17:43`,
      title: "Updated version",
      status: "Building",
      build: 1
    }
  };
  let [state, setState] = useState({
    published: "build1",
    isFormModalOpen: false
  });

  return (
    <div>
      {state.isFormModalOpen && (
        <LauncherVersionPublish
          handleClose={() => {
            setState({
              isFormModalOpen: false
            });
          }}
        />
      )}

      {Object.keys(versions).map((oneVersionId, index) => {
        let oneVersion = versions[oneVersionId];
        return (
          <FormGroup
            indentation="lg"
            // style={{
            //   // marginBottom: '8px',
            //   flexGrow: 0,
            //   padding: "16px",
            //   backgroundColor: "#fafbfc",
            //   position: "relative"
            // }}
          >
            <CardNew wave={false} >
              <FormGroup indentation="xs">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%"
                  }}
                >
                  <StatusDot
                    status={
                      oneVersion["status"] === "Published"
                        ? `enabled`
                        : `testing`
                    }
                  >
                    {oneVersion["status"]}
                  </StatusDot>
                  <div className="ui-mike-sku">{oneVersion["id"]}</div>
                </div>
              </FormGroup>
              <FormGroup indentation="xs">
                <h3>{oneVersion["title"]}</h3>
              </FormGroup>

              <FormGroup border="sm">
                <FormGroup indentation="md">
                  <div
                    style={{
                      fontSize: 13,
                      display: "grid",
                      gridTemplateColumns: "26% 72%",
                      // gridTemplateRows: '200px',
                      gridColumnGap: "2%",
                      // gridRowGap: "40px",
                      width: "100%"
                    }}
                  >
                    <div className="ui-cardnew__section__label">Created:</div>
                    <div
                      style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {`${oneVersion["created"]}`}
                    </div>

                    <div className="ui-cardnew__section__label">Updated:</div>
                    <div
                      style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {`${oneVersion["updated"]}`}
                    </div>

                    {oneVersion["published"] && (
                      <div className="ui-cardnew__section__label">
                        Published:
                      </div>
                    )}
                    {oneVersion["published"] && (
                      <div
                        style={{
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {`${oneVersion["published"]}`}
                      </div>
                    )}

                    {/* {oneVersion['updated']}
                                  {oneVersion['published']} */}
                  </div>
                </FormGroup>

                <FormGroup
                  // label="Project test link"
                  indentation="md">

                    <Button size="sm" appearance="secondary"
                    onClick={handleLink}
                    >
                      {/* <Icon size={20} name="edit"/>&nbsp;&nbsp; */}
                      Customize visual
                    </Button>
                  </FormGroup>

                {oneVersion["status"] === "Ready" && (
                  <FormGroup indentation="md">
                    <Notification
                      title="Test this version"
                      icon="info"
                      status="info"
                      // appearance="minimal"
                    >
                      Вы можете проверить лаунчер с помощью механизма
                      автообновления. Для этого запустите ваш текущий лаучнер с
                      параметром '--stage upstream{" "}
                      <span>{<Icon name="copy" size="sm" />}</span>
                    </Notification>
                  </FormGroup>
                )}

                {oneVersion["status"] === "Building" && (
                  <FormGroup indentation="md">
                    <Notification
                      title="Building in progress"
                      icon="info"
                      status="info"
                      // appearance="minimal"
                    >
                      Please wait. It may take up to 5 minutes to build your
                      launcher.
                    </Notification>
                  </FormGroup>
                )}
              </FormGroup>

              <FormGroup indentation="sm">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >




                 {buttons[oneVersion["status"]]["build"] && <Button
                    appearance="flatten"
                    disabled={false}
                  >
                    <Icon name="build" />&nbsp;&nbsp;Build version
                    {/* {oneVersion["status"] !== "Building"
                      ? `Build version`
                      : // : `Building...(${oneVersion["build"]}%)`}
                        `Building...`} */}
                  </Button>}


                  {buttons[oneVersion["status"]]["download"] && <div style={{display: 'flex', placeContent: 'flex-start center'}}>

                    <div style={{display: 'flex', placeContent: 'flex-start center'}}>
                    <Button
                      appearance="flatten"
                      disabled={
                        oneVersion["status"] === "Building" ||
                        !oneVersion["build"]
                          ? true
                          : false
                      }
                    >
                      <Icon name="cloud-filled-download" />&nbsp;&nbsp;Download build
                    </Button><div style={{padding: '0 16px', color: '#ccc', }}>|</div>
                    </div>

                    {!oneVersion["published"] && !buttons[oneVersion["status"]]["building"] && <Button
                      appearance="flatten"
                      disabled={
                        oneVersion["status"] === "Building" ||
                        !oneVersion["build"]
                          ? true
                          : false
                      }
                    >
                      <Icon name="build" />&nbsp;&nbsp;Rebuild
                    </Button>}

                  </div>}

                  {buttons[oneVersion["status"]]["building"] && <Button
                    appearance="flatten"
                    disabled={
                      oneVersion["status"] === "Building" ||
                      !oneVersion["build"]
                        ? true
                        : false
                    }
                  >
                      <span
                        style={{
                          // position: "absolute",
                          // left: "50%",
                          zIndex: 100,
                          marginRight: "4px",
                          width: "24px",
                          height: "24px",
                          // border: '1px solid red',
                          backgroundSize: '24px 24px',
                          // background: '100% 100% url("data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 50 50"><path fill="currentColor" d="M25.251 6.461c-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg>")',
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 50 50"><path fill="currentColor" d="M25.251 6.461c-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg>
                      </span>

                    Building...
                  </Button>}


                  <Button
                    onClick={() => setState({ isFormModalOpen: true })}
                    appearance="flatten"
                    // appearance="outline"
                    size="sm"
                    disabled={
                      oneVersion["published"] ||
                      oneVersion["status"] === "Building" ||
                      !oneVersion["build"]
                        ? true
                        : false
                    }
                  >
                    {/* <Icon name="checkmark" /> */}
                    Publish
                  </Button>
                </div>
              </FormGroup>
            </CardNew>
          </FormGroup>
        );
      })}
    </div>
  );
}
export default withRouter(props => {
  return <PAlauncherVersions {...props} />;
});





function LauncherVersionPublish({
  handleClose = () => {
    void 0;
  }
}) {
  let [pubState, setPubState] = useState(false);

  const invertState = () => {
    setPubState(!pubState);
  };

  return (
    <React.Fragment>
      <div className="xsui-modal xsui-modal--size-md">
        <div className="xsui-modal__overlay" />
        <div
          className="xsui-modal__entry"
          style={{ transition: "all 150ms ease-in-out" }}
        >
          {/* newWidget Widget */}

          <div
            className="xsui-modal__close"
            data-id="close_modal"
            onClick={e => {
              handleClose();
            }}
          />

          <div className="xsui-content-block xsui-content-block--appearance-modal">
            <div>
              {/* <Head>Launcher publishing</Head> */}
              <div
                className="modal-alert"
                style={{
                  display: "flex",
                  alignItems: "stretch"
                }}
              >
                <FormGroup border="lg">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "100%"
                    }}
                  >
                    <img
                      className="modal-alert__icon"
                      src="https://uikit.xsolla.com/static/981e91bf767ccf82cd8f57caf45483c7.svg"
                    />

                    <div className="modal-alert__title">
                      Publish new version?
                    </div>
                    <div className="">
                      The current version of the launcher (published on Apr, 12,
                      2019 18:33) will be replaced.
                    </div>
                    <div className="modal-alert__confirmation">
                      <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md xsui-form-group--centered">
                        <div className="xsui-form-group__entry">
                          <div className="xsui-checkbox xsui-checkbox--primary">
                            <div className="xsui-checkbox__wrapper">
                              <Checkbox
                                name="checkbox"
                                label="Yes, I understand effect"
                                input={{
                                  value: pubState,
                                  onChange: invertState
                                }}
                                // disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </FormGroup>

                <FormGroup
                  label="Commit message"
                  tooltip="Optionally add a message for yourself"
                >
                  <Input
                    input={{
                      // disabled: true,
                      // name: 'with-icon',
                      value: "Visual changes",
                      // extraLabel: this.currLocked ? "DEFAULT" : null
                      onChange: () => {
                        void 0;
                      }
                    }}
                    offset="right"
                    // extra={
                    //   <Icon
                    //     name={"copy"}
                    //     hoverable={true}
                    //     // onClick={e => this.handeCurrDel(this.id, e)}
                    //   />
                    // }
                  />
                </FormGroup>
              </div>

              <FormFooter sticky={true}>
                {/* <Button appearance="outline"
                  // onClick={() => closeModal('isFormModalOpen')}
                  onClick={() => void(0)}
                  >
                    Later
                  </Button> */}
                <Button
                  disabled={pubState ? false : true}
                  type="submit"
                  // onClick={() => closeModal('isFormModalOpen')}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Publish
                </Button>
              </FormFooter>

              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
